var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:marketing:preview-product:list"],
            expression: "['platform:marketing:preview-product:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          request: _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "page-operation",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["platform:marketing:preview-product:save"],
                        expression:
                          "['platform:marketing:preview-product:save']",
                      },
                    ],
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.handleAdd },
                  },
                  [_vm._v("新增")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "table-image",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  { staticClass: "demo-image__preview line-heightOne" },
                  [
                    _c("el-image", {
                      attrs: {
                        src: row.image,
                        "preview-src-list": [row.image],
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "table-isShow",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  [
                    _c("el-switch", {
                      attrs: {
                        "active-value": true,
                        "inactive-value": false,
                        "active-text": "开启",
                        "inactive-text": "关闭",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(row)
                        },
                      },
                      model: {
                        value: row.isShow,
                        callback: function ($$v) {
                          _vm.$set(row, "isShow", $$v)
                        },
                        expression: "row.isShow",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "table-updater",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(" " + _vm._s(row.updater || row.creator) + " ")]
            },
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "160",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: [
                                    "platform:marketing:preview-product:update",
                                  ],
                                  expression:
                                    "['platform:marketing:preview-product:update']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleActivity(row, "edit")
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: [
                                    "platform:marketing:preview-product:delete",
                                  ],
                                  expression:
                                    "['platform:marketing:preview-product:delete']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }